import styles from './Loader.scss'
import loaderImg from '../../assets/spinner.gif'
import ReactDOM from 'react-dom'

const Loader = () => {
  return ReactDOM.createPortal (
    <div className={styles.wrapper}>
      <div className={styles.loader}>
        <img src={loaderImg} alt="loading..." />
      </div>
    </div>,
    document.getElementById("loader")
  )
}

export default Loader
